<template>
    <BorrarModalComponent
        :name="'borrar-sancion-' + sancion.id"
        :title="'Borrar sancón de' + abonado.name + ' ' + abonado.surnames"
        borrarTitle="Datos del abonado"
        confirmButton="¿BORRAR SANCIÓN?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarAbonado()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Nª de abonado:</b> <a>{{ abonado.n_abonado }}</a>
            </li>
            <li class="list-group-item">
                <b>Nombre:</b> <a>{{ abonado.name }}</a>
            </li>
            <li class="list-group-item">
                <b>Apellidos:</b> <a>{{ abonado.surnames }}</a>
            </li>
            <li class="list-group-item">
                <b>DNI:</b> <a>{{ abonado.dni }}</a>
            </li>
            <li class="list-group-item">
                <b>Email:</b> <a>{{ abonado.email }}</a>
            </li>
            <li class="list-group-item">
                <b>Asiento Zona:</b>
                <a>
                    <template v-if="abonado.tiene_asiento">
                        <strong>Zona:</strong> {{ abonado.asiento.region }}, Fila: {{ abonado.asiento.row }}, Butaca: {{ abonado.asiento.seat }}
                    </template>
                    <template v-else>
                        Sin asiento
                    </template>
                </a>
            </li>
            <li class="list-group-item">
                <b>Fecha de inicio: </b>
                <a>{{ sancion.fecha_inicio }}</a>
            </li>
            <li class="list-group-item">
                <b>Fecha de fin: </b>
                <a>{{ sancion.fecha_fin }}</a>
            </li>
            <li class="list-group-item">
                <b>Acceso bloqueado: </b>
                <a>
                    <CheckOrCross :condition="sancion.bloquear_acceso"/>
                </a>
            </li>
            <li class="list-group-item">
                <b>Motivo: </b>
                <a v-html="sancion.motivo"></a>
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>

    import CheckOrCross from "../../../../components/backend/components/CheckOrCross";
    import BorrarModalComponent from "../../../../components/backend/components/BorrarModalComponent";

    export default {
        props: ['abonado', 'sancion'],
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-sancion-' + this.sancion.id, borrado);
            },
            borrarAbonado() {
                const params = {
                    filters : {},
                    abonado_id: this.abonado.id,
                    sancion_id: this.sancion.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.sancion.borrar'), params).then(res => {
                    this.$toast.success("Sanción borrada con correctamente.");
                    this.close(true);
                });
            }
        },
        components: {
            BorrarModalComponent,
            CheckOrCross
        }
    }
</script>
